var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bag-check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,7H17a5.0071,5.0071,0,0,0-5-5A5.0059,5.0059,0,0,0,7,7H6.5A2.5026,2.5026,0,0,0,4,9.5v10A2.5026,2.5026,0,0,0,6.5,22h6a.5.5,0,0,0,0-1h-6A1.5017,1.5017,0,0,1,5,19.5V9.5A1.5017,1.5017,0,0,1,6.5,8h11A1.5017,1.5017,0,0,1,19,9.5v5a.5.5,0,0,0,1,0v-5A2.5026,2.5026,0,0,0,17.5,7ZM12,3a4.0078,4.0078,0,0,1,4,4H8A4.0042,4.0042,0,0,1,12,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8535,17.8535l-3.5,3.5a.5.5,0,0,1-.707,0l-1.5-1.5a.5.5,0,0,1,.707-.707L16,20.293l3.1465-3.1465a.5.5,0,0,1,.707.707Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.a7baffdd125973b8aea0ce8907e9b7ac.svg";
export { ForwardRef as ReactComponent };